var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement } from "react";
import { IconButton as MuiIconButton, Stack, } from "@mui/material";
import { iconButtonStyles } from "./IconButton.styles";
import CircularProgress from "../Progress/CircularProgress/CircularProgress";
var IconButton = function (_a) {
    var selected = _a.selected, dragged = _a.dragged, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, title = _a.title, loading = _a.loading, sx = _a.sx, size = _a.size, _c = _a.className, className = _c === void 0 ? "" : _c, iconProps = _a.iconProps, children = _a.children, rest = __rest(_a, ["selected", "dragged", "variant", "title", "loading", "sx", "size", "className", "iconProps", "children"]);
    var variantClassName = "MuiIconButton-".concat(variant);
    var stateClassName = selected
        ? "MuiIconButton-selected"
        : dragged
            ? "MuiIconButton-dragged"
            : "";
    var loadingSize = variant === "primary" || variant === "dark" || size === "medium" ? 20 : 24;
    return (_jsx(MuiIconButton, __assign({ className: "".concat(className, " ").concat(variantClassName, " ").concat(stateClassName), title: title, size: size
            ? size
            : variant === "primary" || variant === "dark"
                ? "small"
                : "large", sx: __assign(__assign({}, iconButtonStyles), sx) }, rest, { children: loading ? (_jsx(Stack, __assign({ width: loadingSize, height: loadingSize, justifyContent: "center", alignItems: "center" }, { children: _jsx(CircularProgress, { color: "secondary", style: { width: 14, height: 14 } }) }))) : (cloneElement(children, __assign(__assign({}, (variant === "primary" ||
            variant === "dark" ||
            (size === "medium" && variant === "ctaAlt")
            ? { fontSize: "small" }
            : {})), iconProps))) })));
};
export default IconButton;
